import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

import { toast } from 'react-toastify';
import { Container } from '../../styles/GlobalStyles';
import SideBar from '../../components/SideBar';
import VisualizarProva from '../../components/VisualizarProva';
import axios from '../../services/axios';

export default function ProvasCompletas({ match }) {
  const id = get(match, 'params.id', '');

  const [dados, setDados] = useState([]);

  useEffect(() => {
    async function callQuestions() {
      try {
        const data = await axios('/disciplina/');

        setDados(...[data.data.filter((d) => d.id_identificacao_empresa
          === Number(id))]);
      } catch {
        toast.error('Não foi possível carregar a prova.');
      }
    }

    callQuestions();
  }, [id]);

  return (
    <VisualizarProva disciplinas={dados} />
  );
}

ProvasCompletas.propTypes = {
  match: PropTypes.shape({}).isRequired,
};
